export const metricLabelFormatter = (metricId: string | undefined): string => {
    // camelCase to space separated caps
    if (!metricId) {
        return '';
    }
    const words = metricId.split(/(?=[A-Z])/).map(word => word[0].toUpperCase() + word.slice(1));
    return words.join(' ').toUpperCase();
};
